const styleId = 'icf-easter-egg-wobble-style'

// Styles are injected from JS on purpose: PurgeCSS only scans
// php/html/jsx/tsx sources, so classes referenced solely in this .ts file
// would be purged from the compiled stylesheets.
const css = `
.icf-easter-egg-wobble {
  animation: icf-easter-egg-wobble var(--icf-egg-wobble-duration, 0.8s) ease-in-out;
}

@keyframes icf-easter-egg-wobble {
  0%, 100% { transform: rotate(0) scale(1); }
  15% { transform: rotate(calc(var(--icf-egg-wobble-angle, 8deg) * -1)) scale(var(--icf-egg-wobble-scale, 1)); }
  30% { transform: rotate(calc(var(--icf-egg-wobble-angle, 8deg) * 0.875)) scale(var(--icf-egg-wobble-scale, 1)); }
  45% { transform: rotate(calc(var(--icf-egg-wobble-angle, 8deg) * -0.625)) scale(var(--icf-egg-wobble-scale, 1)); }
  60% { transform: rotate(calc(var(--icf-egg-wobble-angle, 8deg) * 0.5)) scale(1); }
  75% { transform: rotate(calc(var(--icf-egg-wobble-angle, 8deg) * -0.25)) scale(1); }
}

.icf-easter-egg-wobble--wild {
  animation: icf-easter-egg-wobble-wild 1.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes icf-easter-egg-wobble-wild {
  0% { transform: rotate(0) scale(1); }
  15% { transform: rotate(-25deg) scale(1.15); }
  30% { transform: rotate(25deg) scale(1.3); }
  70% { transform: rotate(740deg) scale(1.35); }
  85% { transform: rotate(712deg) scale(1.05); }
  100% { transform: rotate(720deg) scale(1); }
}
`

function injectStyles() {
  if (document.getElementById(styleId)) return
  const style = document.createElement('style')
  style.id = styleId
  style.textContent = css
  document.head.appendChild(style)
}

/**
 * Shake an existing element, e.g. the logo after the hidden click combo.
 * Intensity 1 is a gentle wiggle and each step shakes harder; 7 and up
 * goes full celebration mode (two full spins with overshoot).
 */
export function wobbleElement(
  element: HTMLElement,
  options: { intensity?: number } = {}
) {
  const { intensity = 1 } = options
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  injectStyles()

  const wild = intensity >= 7
  element.classList.remove(
    'icf-easter-egg-wobble',
    'icf-easter-egg-wobble--wild'
  )
  // force a reflow so re-adding the class restarts a running animation
  void element.offsetWidth

  if (!wild) {
    element.style.setProperty(
      '--icf-egg-wobble-angle',
      `${5 + intensity * 3.5}deg`
    )
    element.style.setProperty(
      '--icf-egg-wobble-scale',
      `${1 + intensity * 0.02}`
    )
    element.style.setProperty(
      '--icf-egg-wobble-duration',
      `${0.8 + intensity * 0.05}s`
    )
  }

  element.classList.add(
    wild ? 'icf-easter-egg-wobble--wild' : 'icf-easter-egg-wobble'
  )
  element.addEventListener(
    'animationend',
    () =>
      element.classList.remove(
        'icf-easter-egg-wobble',
        'icf-easter-egg-wobble--wild'
      ),
    { once: true }
  )
}
